export default function CertificationDetails() {
  return (
    <section id="certification-details" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-rose-100 px-6 py-2 rounded-full mb-6">
            <span className="text-sm font-bold text-rose-600 tracking-wider">
              CERTIFICATION DETAILS
            </span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            認定プログラム詳細
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            3日間の集中プログラムで、エデュケーターとしての知識とスキルを学びます
          </p>
        </div>

        {/* Program Overview Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          <div className="bg-gradient-to-br from-rose-50 to-pink-50 p-8 rounded-2xl border border-rose-100">
            <div className="w-14 h-14 bg-rose-500 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-calendar-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              3日間の集中プログラム
            </h3>
            <p className="text-gray-600 leading-relaxed">
              理論から実践まで、エデュケーターに必要なすべてを学びます
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-8 rounded-2xl border border-purple-100">
            <div className="w-14 h-14 bg-purple-500 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">場所</h3>
            <p className="text-gray-600 leading-relaxed">
              ①オンライン<br />
              ②マイアスセミナールーム<br />
              ③各ディーラー<br />
              ④地方開催
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-8 rounded-2xl border border-amber-100">
            <div className="w-14 h-14 bg-amber-500 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">期間</h3>
            <p className="text-gray-600 leading-relaxed">
              3日間<br />
              （各4時間、テストを含む）
            </p>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-8 rounded-2xl border border-teal-100">
            <div className="w-14 h-14 bg-teal-500 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">受講資格</h3>
            <p className="text-gray-600 leading-relaxed">
              ①ネイリスト歴3年以上<br />
              ②ベーシックアップ受講済み
            </p>
          </div>
        </div>

        {/* Pricing */}
        <div className="bg-gradient-to-br from-rose-500 to-pink-600 rounded-3xl p-12 text-center mb-20 shadow-xl">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">費用（税込）</h3>
            <div className="text-6xl font-bold text-white mb-4">¥112,975</div>
            <p className="text-rose-100 text-lg">
              （教材費込み）
            </p>
          </div>
        </div>

        {/* Daily Schedule */}
        <div className="space-y-8">
          {/* Day 1 */}
          <div className="bg-white rounded-3xl border-2 border-rose-200 overflow-hidden hover:shadow-2xl transition-all duration-300">
            <div className="bg-gradient-to-r from-rose-500 to-pink-500 p-8">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-rose-100 text-sm font-bold mb-2">
                    DAY 1
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-2">
                    ベーシック（4時間）
                  </h3>
                  <p className="text-rose-100">
                    Miss Mirageアドバイザー資格取得
                  </p>
                </div>
                <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center">
                  <i className="ri-book-open-line text-4xl text-white"></i>
                </div>
              </div>
            </div>
            <div className="p-8">
              <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                <span className="w-2 h-2 bg-rose-500 rounded-full mr-3"></span>
                内容
              </h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-rose-300 rounded-full mr-4 mt-2"></div>
                  <p className="text-gray-700 leading-relaxed flex-1">
                    ミスミラージュの商品知識
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-rose-300 rounded-full mr-4 mt-2"></div>
                  <p className="text-gray-700 leading-relaxed flex-1">
                    アドバイザー資格取得
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-rose-300 rounded-full mr-4 mt-2"></div>
                  <p className="text-gray-700 leading-relaxed flex-1">
                    ネイル技能検定の内容についてのデモンストレーションとレッスン
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-rose-300 rounded-full mr-4 mt-2"></div>
                  <div className="flex-1">
                    <p className="text-gray-700 leading-relaxed font-semibold mb-2">
                      ネイル基礎学
                    </p>
                    <ul className="ml-4 space-y-2">
                      <li className="text-gray-600 leading-relaxed">
                        • ジェルネイルについての基礎知識
                      </li>
                      <li className="text-gray-600 leading-relaxed">
                        • ネイリストジェル技能検定の内容についてのデモンストレーションとレッスン
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Day 2 */}
          <div className="bg-white rounded-3xl border-2 border-purple-200 overflow-hidden hover:shadow-2xl transition-all duration-300">
            <div className="bg-gradient-to-r from-purple-500 to-indigo-500 p-8">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-purple-100 text-sm font-bold mb-2">
                    DAY 2
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-2">
                    エデュケーター（4時間）
                  </h3>
                  <p className="text-purple-100">
                    教育者としてのスキルを習得
                  </p>
                </div>
                <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center">
                  <i className="ri-presentation-line text-4xl text-white"></i>
                </div>
              </div>
            </div>
            <div className="p-8">
              <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                内容
              </h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-purple-300 rounded-full mr-4 mt-2"></div>
                  <p className="text-gray-700 leading-relaxed flex-1">
                    エデュケーターとしての心構え
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-purple-300 rounded-full mr-4 mt-2"></div>
                  <p className="text-gray-700 leading-relaxed flex-1">
                    ネイリストジェル技能検定の内容についてのデモンストレーションとレッスン
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Day 3 */}
          <div className="bg-white rounded-3xl border-2 border-amber-200 overflow-hidden hover:shadow-2xl transition-all duration-300">
            <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-8">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-amber-100 text-sm font-bold mb-2">
                    DAY 3
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-2">
                    キャリアアップ（4時間）
                  </h3>
                  <p className="text-amber-100">
                    エデュケーター試験とキャリアアップ講習
                  </p>
                </div>
                <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center">
                  <i className="ri-trophy-line text-4xl text-white"></i>
                </div>
              </div>
            </div>
            <div className="p-8">
              <div className="mb-8">
                <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                  <span className="w-2 h-2 bg-amber-500 rounded-full mr-3"></span>
                  エデュケーター試験
                </h4>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-amber-300 rounded-full mr-4 mt-2"></div>
                    <p className="text-gray-700 leading-relaxed flex-1">
                      筆記試験（理論・知識の確認）
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-amber-300 rounded-full mr-4 mt-2"></div>
                    <p className="text-gray-700 leading-relaxed flex-1">
                      実技試験（技術力の評価）
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-amber-300 rounded-full mr-4 mt-2"></div>
                    <p className="text-gray-700 leading-relaxed flex-1">
                      合格後ディプロマ取得
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-t-2 border-amber-100 pt-8">
                <h4 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                  <span className="w-2 h-2 bg-amber-500 rounded-full mr-3"></span>
                  キャリアアップ講習
                </h4>
                <div className="bg-amber-50 rounded-2xl p-6 mb-6">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <strong>試験の合否に関わらず、以下の内容を学べます：</strong>
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-amber-400 rounded-full mr-4 mt-2"></div>
                      <p className="text-gray-700 leading-relaxed flex-1">
                        エデュケーター公式テキストを使って各自がネイリスト養成スクールを開講できるようアドバイス
                      </p>
                    </div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-amber-400 rounded-full mr-4 mt-2"></div>
                      <p className="text-gray-700 leading-relaxed flex-1">
                        サロンで使えるフィルイン技術のレクチャー
                      </p>
                    </div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-amber-400 rounded-full mr-4 mt-2"></div>
                      <p className="text-gray-700 leading-relaxed flex-1">
                        トレンドアートのレクチャー
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-amber-500">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    <i className="ri-information-line text-amber-500 mr-2"></i>
                    あくまでアドバイスであり、申請による教育開催権の認定等はありません
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Optimized Version */}
        <div className="lg:hidden mt-12 space-y-6">
          <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-6 border border-rose-200">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-rose-500 rounded-xl flex items-center justify-center mr-4">
                <i className="ri-book-open-line text-xl text-white"></i>
              </div>
              <div>
                <div className="text-xs font-bold text-rose-600 mb-1">
                  DAY 1
                </div>
                <h4 className="text-lg font-bold text-gray-900">
                  ベーシック（4時間）
                </h4>
              </div>
            </div>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start">
                <span className="text-rose-500 mr-2">•</span>
                <span>ミスミラージュの商品知識</span>
              </li>
              <li className="flex items-start">
                <span className="text-rose-500 mr-2">•</span>
                <span>アドバイザー資格取得</span>
              </li>
              <li className="flex items-start">
                <span className="text-rose-500 mr-2">•</span>
                <span>Miss Mirageアドバイザー資格取得</span>
              </li>
              <li className="flex items-start">
                <span className="text-rose-500 mr-2">•</span>
                <span>ネイル技能検定の内容についてのデモンストレーションとレッスン</span>
              </li>
              <li className="flex items-start">
                <span className="text-rose-500 mr-2">•</span>
                <span>ネイル基礎学(ジェルネイルの基礎知識、ネイリストジェル技能検定)</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-6 border border-purple-200">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center mr-4">
                <i className="ri-presentation-line text-xl text-white"></i>
              </div>
              <div>
                <div className="text-xs font-bold text-purple-600 mb-1">
                  DAY 2
                </div>
                <h4 className="text-lg font-bold text-gray-900">
                  エデュケーター（4時間）
                </h4>
              </div>
            </div>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start">
                <span className="text-purple-500 mr-2">•</span>
                <span>エデュケーターとしての心構え</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-500 mr-2">•</span>
                <span>ネイリストジェル技能検定の内容についてのデモンストレーションとレッスン</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 border border-amber-200">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center mr-4">
                <i className="ri-trophy-line text-xl text-white"></i>
              </div>
              <div>
                <div className="text-xs font-bold text-amber-600 mb-1">
                  DAY 3
                </div>
                <h4 className="text-lg font-bold text-gray-900">
                  キャリアアップ（4時間）
                </h4>
              </div>
            </div>
            <div className="space-y-3 text-sm text-gray-700">
              <div>
                <p className="font-semibold mb-2">エデュケーター試験</p>
                <ul className="space-y-1 ml-4">
                  <li className="flex items-start">
                    <span className="text-amber-500 mr-2">•</span>
                    <span>筆記試験</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-amber-500 mr-2">•</span>
                    <span>実技試験</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-amber-500 mr-2">•</span>
                    <span>合格後ディプロマ取得</span>
                  </li>
                </ul>
              </div>
              <div>
                <p className="font-semibold mb-2">キャリアアップ講習</p>
                <ul className="space-y-1 ml-4">
                  <li className="flex items-start">
                    <span className="text-amber-500 mr-2">•</span>
                    <span>スクール開講アドバイス</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-amber-500 mr-2">•</span>
                    <span>フィルイン技術</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-amber-500 mr-2">•</span>
                    <span>トレンドアート</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}